export * from "./cCSAuthentication.service";
import { CCSAuthenticationService } from "./cCSAuthentication.service";
export * from "./oAuth2.service";
import { OAuth2Service } from "./oAuth2.service";
export const APIS = [CCSAuthenticationService, OAuth2Service];
